import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-0880292d"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "page_404"
};
var _hoisted_2 = {
  class: "container"
};

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "four_zero_four_bg"
  }, [/*#__PURE__*/_createElementVNode("h1", {
    class: "text-center"
  }, "404")], -1);
});

var _hoisted_4 = {
  class: "contant_box_404"
};

var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h3", {
    class: "h2"
  }, "啊哦，出错啦", -1);
});

var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", null, "你寻找的页面走丢啦!", -1);
});

var _hoisted_7 = /*#__PURE__*/_createTextVNode("返回主页");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_router_link = _resolveComponent("router-link");

  return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_hoisted_5, _hoisted_6, _createVNode(_component_router_link, {
    to: "/",
    class: "link_404"
  }, {
    default: _withCtx(function () {
      return [_hoisted_7];
    }),
    _: 1
  })])])]);
}